/**
 * Telemetry kept around a lap beyond its crossings, so sensor fusion has
 * converged and GPS smoothing windows are full before the lap's first
 * sample. The trimming stage keeps this much around a session's racing
 * range; a lap's raw telemetry carries this much either side of its window
 * so a shared lap reloads with the same context its session had.
 */
export const SENSOR_CONTEXT_MS = 10_000
